import { memo, useState } from "react";
import { Controller } from "react-hook-form";
import Accordion from "../accordian";
import { useTranslation } from "react-i18next";
import TextAreaInput from "../inputs/TextAreaInput";

interface ScopeOfWorkCardProps {
  control: any;
  errors: any;
  // userAppointmentDetails?: UserAppointment | ContractorDetails;
  isFieldsDisabled: boolean;
}

const ScopeOfWorkCard = ({
  control,
  errors,
  isFieldsDisabled,
}: ScopeOfWorkCardProps) => {
  const { t } = useTranslation();
  const [selectedKey, setSelectedKey] = useState<string>("1");

  return (
    <div className="bg-white p-4 rounded-xl flex flex-col gap-3 lg:gap-6 shadow-[0px_1px_5px_0px_rgba(113,112,163,0.3)]">
      <Accordion
        selectedKey={selectedKey}
        onSelectionChange={setSelectedKey}
        title={
          <h1 className="text-start text-xl sm:text-2xl flex flex-1 -mt-2 items-center">
            {t("2")}. {t("scopeOfWork")}
          </h1>
        }
      >
        <Controller
          name="scopeOfWork"
          control={control}
          render={({ field: { onChange, name, value } }) => (
            <TextAreaInput
              rows={4}
              label={t("detailedScopeOfWork")}
              onChange={onChange}
              value={value}
              error={errors?.[name]?.message}
              required
              minLength={200}
              maxLength={500}
              readOnly={isFieldsDisabled}
            />
          )}
        />
      </Accordion>
    </div>
  );
};

export default memo(ScopeOfWorkCard);
